import {Component, inject, OnDestroy, Signal} from '@angular/core';
import {Store} from '@ngrx/store';
import {ActivatedRoute, Router} from '@angular/router';
import {stages} from '../../permit-for-oversize-vehicles.routes';
import {EntityOrderingTheRideForm} from './forms/entity-ordering-the-ride.form';
import {selectApplication, selectLoading, selectPending} from '../../../../../../store/selectors/application.selectors';
import {ApplicationAppEntityApplicationRead} from '../../../../../../openapi';
import {Subscription} from 'rxjs';
import {toObservable} from '@angular/core/rxjs-interop';
import {updateApplication} from '../../../../../../store/actions/application.actions';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {SpinnerComponent} from '../../../../../../common/spinner/spinner.component';
import {StagesComponent} from '../../../../../../common/stages/stages.component';
import {ValidationErrorsComponent} from '../../../../../../common/validation-errors/validation-errors.component';
import {NgxMaskDirective} from 'ngx-mask';

@Component({
  selector: 'app-entity-ordering-the-ride-section',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent,
    StagesComponent,
    ValidationErrorsComponent,
    NgxMaskDirective
  ],
  providers: [EntityOrderingTheRideForm],
  templateUrl: './entity-ordering-the-ride-section.component.html'
})
export class EntityOrderingTheRideSectionComponent implements OnDestroy {

  public stages = stages;

  public store$: Store = inject(Store);

  public router: Router = inject(Router);

  public route: ActivatedRoute = inject(ActivatedRoute);

  public form: EntityOrderingTheRideForm = inject(EntityOrderingTheRideForm);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.application()?.uuid || '',
        application: this.form.value,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-przejazdu'], {relativeTo: this.route});
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }

}
